module.exports = __webpack_public_path__ + "img/cruksnl.bf203eea.png";